import logoimg from '../assets/images/logo-hospital.png';
import './Footer.css';
import { FaInstagram, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

function Footer() {
    return (
        <footer className="footer-main" id='footer'>
            <div className="container">
                <div className="footer-top">
                    <div className="row">
                        <div className='col-lg-5 col-md-12 footer-brand'>
                            <div className="footer-logo-container">
                                <img src={logoimg} alt='JDS Hospital' className='footer-logo' />
                            </div>
                            <p className="footer-desc">
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                            </p>

                        </div>

                        <div className='col-lg-3 col-md-6 footer-links'>
                            <h4 className="footer-heading">COMPANY</h4>
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><a href="/About">About us</a></li>
                                <li><a href="#">Delivery</a></li>
                                <li><a href="#">Privacy policy</a></li>
                            </ul>
                        </div>

                        <div className='col-lg-4 col-md-6 footer-contact'>
                            <h4 className="footer-heading">GET IN TOUCH</h4>
                            <ul className="contact-list">
                                <li>
                                    <FaMapMarkerAlt className="contact-icon" />
                                    <span>JDS Hospital, Seethammadara, Visakhapatnam – 530013</span>
                                </li>
                                <li>
                                    <FaPhoneAlt className="contact-icon" />
                                    <span>08912717711, 08912551697, 08914052667</span>
                                </li>
                                <li>
                                    <FaEnvelope className="contact-icon" />
                                    <span>info@jdshospitals.com</span>
                                </li>
                            </ul>
                            <div className="social-links mt-4">
                                <a href="https://www.instagram.com/jdshospitals/?hl=en" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p className="copyright-text">
                        Copyright 2025 @ JDS HOSPITALS - All Right Reserverd.
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;